import React from "react";
import {getDate} from "../../../constant/DateUtils";

const FilterResult = () =>{
    return(
        <div className="header_ext">
            <div>
                <div className="box_formthongkexoso">
                    <h3 className="slecttk">Dò vé số Online - May mắn mỗi ngày!...</h3>

                    <div>
                        <div>
                            <form id="doveso" name="doveso" method="get"
                                  action="/">
                                <table border="0" align="center" cellPadding="0"
                                       cellSpacing="2" width="100%"
                                       style={{maxWidth: "400px"}}>
                                    <tbody>
                                    <tr>
                                        <td align="left" nowrap="nowrap">Ng&agrave;y:</td>
                                        <td align="left" nowrap="nowrap">
                                            <input name="ngay" type="text"
                                                   id="frm_dove_ngay" style={{width: "75px"}}
                                                   defaultValue={getDate()}/>

                                        </td>
                                        <td align="right" nowrap="nowrap">Tỉnh:</td>
                                        <td align="left" nowrap="nowrap">
                                            <select name="tinh" id="frm_dove_tinh"
                                                    style={{width: "100px"}}>
                                            </select>

                                        </td>

                                    </tr>
                                    <tr>
                                        <td align="left" nowrap="nowrap">Vé Số:</td>
                                        <td align="left" nowrap="nowrap">
                                            <input name="so"
                                                   type="text"
                                                   id="doveso_so"
                                                   style={{
                                                       color: "#F00",
                                                       fontSize: "14px",
                                                       fontWeight: "bold",
                                                       textAlign: "center",
                                                       width: "75px"
                                                   }}
                                                   size="10"
                                                   maxLength="6"
                                                   defaultValue=""/>
                                        </td>
                                        <td colSpan="2" align="right" nowrap="nowrap"><input
                                            type="submit" className="btnxemthongke"
                                            value="Dò Kết Quả"/></td>
                                    </tr>
                                    </tbody>
                                </table>
                            </form>
                        </div>
                    </div>
                </div>
                <div className="clear"/>
            </div>
        </div>
    );

};
export default FilterResult;
